import script from "./security.vue?vue&type=script&setup=true&lang=js"
export * from "./security.vue?vue&type=script&setup=true&lang=js"

import "./security.vue?vue&type=style&index=0&id=27d11adf&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d11adf"]])

export default __exports__